// Appends a width parameter to Shopify CDN image URLs so the browser receives
// a resized image instead of the full original.
export function shopifyImageUrl(url, width) {
  if (!url || !width) return url;
  try {
    const u = new URL(url);
    u.searchParams.set('width', String(width));
    return u.toString();
  } catch {
    return url;
  }
}

function normalizeOptionValue(value = '') {
  return value.trim().toLowerCase();
}

export function getShortProductTitle(title = '') {
  return title.split('|')[0].trim();
}

export function formatProductPrice(price) {
  if (!price) return null;
  const amount = parseFloat(price.amount);
  const formattedAmount = amount.toLocaleString('en-IN', {
    minimumFractionDigits: price.currencyCode === 'INR' ? 0 : 2,
    maximumFractionDigits: price.currencyCode === 'INR' ? 0 : 2,
  });
  return price.currencyCode === 'INR'
    ? `₹${formattedAmount}`
    : `${price.currencyCode} ${formattedAmount}`;
}

function getNormalizedProductImages(product) {
  if (!product?.images) return [];
  return Array.isArray(product.images)
    ? product.images.filter(Boolean)
    : product.images.edges?.map((edge) => edge.node).filter(Boolean) ?? [];
}

export function getProductCardImages(product) {
  if (!product) return { primaryImage: null, hoverImage: null };
  const images = getNormalizedProductImages(product);
  return {
    primaryImage: images[0] || null,
    hoverImage: images[1] || null,
  };
}

export function getProductImageNodes(product) {
  return getNormalizedProductImages(product);
}

export function getProductVariants(product) {
  if (!product?.variants) return [];
  if (Array.isArray(product.variants)) return product.variants.filter(Boolean);
  return product.variants.edges?.map((edge) => edge.node).filter(Boolean) ?? [];
}

export function getProductVariantColorLabel(product = {}, variant = {}) {
  const colorOption = variant.selectedOptions?.find((option) => /colou?r/i.test(option.name));
  return colorOption?.value || null;
}

export function getProductColorOptions(product = {}) {
  const grouped = new Map();

  getProductVariants(product).forEach((variant) => {
    const label = getProductVariantColorLabel(product, variant);
    const key = normalizeOptionValue(label || '');
    if (!key) return;

    const existing = grouped.get(key);
    if (existing) {
      existing.available = existing.available || variant.availableForSale;
      return;
    }

    grouped.set(key, {
      key,
      label,
      available: Boolean(variant.availableForSale),
    });
  });

  return [...grouped.values()];
}

export function getDefaultProductVariant(product) {
  const variants = getProductVariants(product);
  if (variants.length === 0) return null;
  return variants.find((variant) => variant.availableForSale) || variants[0] || null;
}
